// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"NoData_scroll-black__AgWtj","wrapper":"NoData_wrapper__DPJeg"};